import React, { PureComponent, Fragment } from "react";
import { push } from "connected-react-router";
import { frontloadConnect } from "react-frontload";
import { connect } from "react-redux";
import Swiper from "react-id-swiper";
import moment from "moment";
import { Scrollbars } from "react-custom-scrollbars";
import "moment/locale/ru";
import { withRouter } from "react-router-dom";
import { setReviews } from "../redux/actions/reviews";
import { fetchPoints, getPointFromUrl, markToDelete, setPoints, setSearchResult, resetSearchResult } from "../redux/actions/points";
import { setRandomPlaceholder } from '../redux/actions/map';
import { resetModalPin, setModalPin, checkIn, showContacts, setSocialStep } from "../redux/actions/modalPin";
import { setBlog, resetBlog } from "../redux/actions/blog";
import { setAppState } from "../redux/actions/appState";
import MetaPage from "./MetaPage";
import clock from "../img/clock.gif";
import starSvg from "../img/svg/star.svg";
import { setFeedbackStep } from "../redux/actions/modalPin";
import { FeedbackList } from "./FeedbackList";
import { FeedbackStepEnum } from "../enums/feedback-step";
import { CheckIn } from "./Check-In";
import { SharingList } from "./SharingList";
import { SocialStepEnum } from "../enums/social-step";
import { commonService } from "../services/commonService";
import { DonateButton } from './DonateButton';
import { RoundedButton } from './RoundedButton';
import { isEqual, first } from 'lodash';
import classNames from 'classnames';
import clsx from 'clsx';
import { UIRoundedButton } from "@UIKit";
import queryString from 'query-string';

moment.locale("ru");

const frontload = async ({
  match,
  getPointFromUrl,
  fetchPoints,
  isLoaded,
  setPoints,
  pins
}) => {
  const {
    params: { ids }
  } = match;
  const parsedIds = ids.match(/[\d,]+/)[0].split(',').map(p=>p.replace('/','')).map(Number)

  setPoints({ selectedPointIds: parsedIds })

  const hasPreloadedPoints = pins.length && parsedIds.every(parsedId => {
    return pins.findIndex(pin => pin.id === parsedId) !== -1;
  });

  if (hasPreloadedPoints) {
    return;
  }

  if (isLoaded) {
    await fetchPoints(parsedIds);
  } else {
    await getPointFromUrl(parsedIds);
  }
};

@connect(
  ({ modalPin, reviews, blog, appState, points, map, search }) => ({
    ...modalPin,
    ...reviews,
    ...blog,
    ...appState,
    ...search,
    ...map,
    fromRubricator: points.fromRubricator,
    pointObjects: points.pointObjects,
    serviceFunctions: points.filters,
    objectsOnMap: map.objectsOnMap
  }),
  {
    setSocialStep,
    checkIn,
    resetModalPin,
    setModalPin,
    setReviews,
    setFeedbackStep,
    setBlog,
    resetBlog,
    fetchPoints,
    setPoints,
    getPointFromUrl,
    markToDelete,
    setAppState,
    setSearchResult,
    resetSearchResult,
    setRandomPlaceholder,
    showContacts,
    goBack: search => push(`/${search}`)
  }
)
@frontloadConnect(frontload, { onMount: true, onUpdate: false })
class ModalPin extends PureComponent {
  constructor(props) {
    super(props);
    this.swiper = null;
  }

  componentWillUnmount() {
    this.props.setAppState({
      filterIsOpen: false
    });
    this.props.resetModalPin();
  }

  toggleCurtain = (pin) => {
    return () => {
      this.props.showContacts(pin.id);
      commonService.sendEvent({
        category: 'viewContacts',
        action: `Contacts of point ${pin.id} was shown`
      });
    }
  }

  setImg = pin => {
    if (pin && pin.logo) {
      return pin.logo;
    }
    const func = pin.functions[0];
    if (func && func.marker) {
      return func.markerFilterActive;
    }
    return "";
  };

  handlePointUrlName(pins) {
    const { location, history } = this.props;
    const hasName = /\d+-\w+/.test(location.pathname)
    if (hasName) {
      return;
    }
    const firstPin = first(pins);
    const idsWithName = `${firstPin.id}-${commonService.translitPin(firstPin)}`;
    const patchedPathname = location.pathname.replace(/[\d,]+/, idsWithName);
    history.push(patchedPathname + location.search);
  }

  componentDidUpdate(prevProps) {
    if (this.props.map && (
      (!prevProps.objectsOnMap && this.props.objectsOnMap) ||
      (!isEqual(prevProps.pins, this.props.pins) && this.props.pins.length)
    )) {
      this.handlePointUrlName(this.props.pins);
      this.handleBounds(this.props.pins);
    }

    // Handling selection points
    const { match: { params: { ids: previousIds } } } = prevProps;
    const { match: { params: { ids } }} = this.props;

    // fixes https://plusone.atlassian.net/browse/CITY-548
    const [previousId, id] = [
      parseInt(previousIds.split('-')[0], 10),
      parseInt(ids.split('-')[0], 10),
    ];

    if (previousId !== id) {
      this.props.fetchPoints(id);
    }
  }

  handleBounds(pins) {
    const getPoint = pin => ([pin.latitude, pin.longitude])
    const pointsWithCoordiantes = pins.filter(pin => !commonService.isOnlinePoint(pin));
    if (!pointsWithCoordiantes.length) {
      return;
    }
    this.props.map.setCenter(getPoint(pointsWithCoordiantes[0]), 16, {
      checkZoomRange: true,
      duration: 500,
      timingFunctionL: 'ease-in'
    });
  }

  reviewView = reviews => {
    const params = {
      navigation: {
        // nextEl: '.swiper-button-next',
        // prevEl: '.swiper-button-prev'
      }
    };

    if (reviews.length === 1) {
      return (
        <div className="reviews-list__item">
          <div
            className="reviews-list__item-title"
            dangerouslySetInnerHTML={this.createMarkup(reviews[0].authorName)}
          />
          <div className="reviews-list__item-info">
            <div className="reviews-content" dangerouslySetInnerHTML={this.createMarkup(reviews[0].content)} />
          </div>
        </div>
      );
    }

    if (reviews.length === 2) {
      return reviews.map(review => (
        <div className="reviews-list__item">
          <div className="reviews-list__item-title" dangerouslySetInnerHTML={this.createMarkup(review.authorName)} />
          <div className="reviews-list__item-info">
            <div className="reviews-content" dangerouslySetInnerHTML={this.createMarkup(review.content)} />
          </div>
        </div>
      ));
    }

    if (reviews.length > 2) {
      return (
        <Swiper
          {...params}
          ref={node => {
            if (node) {
              this.swiper = node.swiper;
            }
          }}
        >
          {reviews.map(review => (
            <div className="reviews-list__item">
              <div
                className="reviews-list__item-title"
                dangerouslySetInnerHTML={this.createMarkup(review.authorName)}
              />
              <div className="reviews-list__item-info">
                <div className="reviews-content" dangerouslySetInnerHTML={this.createMarkup(review.content)} />
              </div>
            </div>
          ))}
        </Swiper>
      );
    }
  };

  goNext = () => {
    if (this.swiper) this.swiper.slideNext();
  };

  goPrev = () => {
    if (this.swiper) this.swiper.slidePrev();
  };

  close = () => {
    const { location, goBack, resetModalPin, resetBlog, setAppState, setPoints, resetSearchResult, searchQuery, setRandomPlaceholder } = this.props;

    setAppState({ filterIsOpen: false });
    setPoints({ selectedPointIds: [] });


    if (searchQuery) {
      resetSearchResult();
      setRandomPlaceholder();
    }

    goBack(location.search);
    resetModalPin();
    resetBlog();
  };

  createMarkup = text => ({ __html: text });

  handleAbsentPointClick(id) {
    this.props.markToDelete(id);
  }

  renderButtonLink(url, text) {
    const handleClick = () => window.open(url, '_blank');

    return (
      <RoundedButton
        className="RoundedButton RoundedButton--yellow"
        handleClick={handleClick}>
          { text }
      </RoundedButton>
    )
  }

  renderButtons(pin) {
    const { location, history, markToDelete, setFeedbackStep, setSocialStep } = this.props;

    const handleGoNextFeedStep = () => {
      setFeedbackStep(pin.id, FeedbackStepEnum.FEEDBACK_LIST);
    };

    const handleGoNextSocialStep = () => {
      setSocialStep(pin.id, SocialStepEnum.SHARE_SELECTION)
    }

    const handleCopyToClipboard = () => {
      const { href: currentUrl } = window.location;
      commonService.copyToClipboard(currentUrl);
    }

    const handleLeaveReview = () => {
      history.push(`/points/${pin.id}/review${location.search}`);
      setFeedbackStep(pin.id, FeedbackStepEnum.FOUND_INACCURACY);
    };

    const handlePointIsMissed = () => {
      commonService.sendEvent({
        category: 'pointIsMissed',
        action: `Point ${pin.id} is missed`
      });
      markToDelete(pin.id);
    }

    return (
      <div className="user-actions">
        <FeedbackList
          pin={pin}
          goNextStep={handleGoNextFeedStep}
          leaveReview={handleLeaveReview}
          pointIsMissed={handlePointIsMissed}
        />
        <SharingList
          pin={pin}
          location={this.props.location}
          goNextStep={handleGoNextSocialStep}
          copyToClipboard={handleCopyToClipboard}/>
      </div>
    );
  }

  closeModal = () => {
    this.props.setModalPin({ isMarkedToDelete: false });
  };

  renderMarkedToDelete() {
    return (
      <div className="point-modal">
        <div className="fmodal__content">
          <div className="modal__replay">
            <div className="replay">
              <div className="replay__title">Спасибо за участие</div>
              <div className="replay__description">Точка будет помечана как отсутсвующая</div>
              <div className="reviews-links">
                <button onClick={this.closeModal} className="form-submit">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderDonate(pin) {
    const handleClick = () => window.open(pin.fundUrl, '_blank')

    return (
      <DonateButton handleClick={handleClick}/>
    )
  }

  handleCheckIn(pin) {
    const { checkIn } = this.props;
    commonService.sendEvent({
      category: 'pointWasCheckedIn',
      action: `Point ${pin.id} was checked in!`
    })
    checkIn(pin.id);
  }

  goBack = () =>  {
    const { fromRubricator, searchQuery } = this.props;
    this.props.resetModalPin();
    this.props.setPoints({
      selectedPointIds: [],
      fromRubricator: false
    });

    if (fromRubricator) {
      this.props.history.goBack();
    } else {
      this.props.history.push(searchQuery);
      this.props.setAppState({ filterIsOpen: false });
      this.props.setSearchResult({ modalSearchResult: true });
    }
  }

  getMeta = pin => {
    const { hostName, cities, location } = this.props;
    const parsedSearch = queryString.parse(location.search);
    const searchCitySlug = parsedSearch.city;
    const pinsCity = cities.find(city => city.id === pin.city);

    parsedSearch.city = searchCitySlug;

    if (pinsCity && pinsCity.slug)
      parsedSearch.city = pinsCity.slug;

    return {
      title: pin.title,
      description: pin.description,
      canonicalSearch: queryString.stringify(parsedSearch),
      hostName,
      keywords: commonService.composeKeywords(pin)
    }
  };

  handleUrlClick = (pin) => () => {
    commonService.sendEvent({
      category: 'point_site',
      action: `User has clicked on site of ${pin.id}`
    })
  }

  handlePhoneClick = () =>
    commonService.sendEvent({ category: 'Contact', action: `phone` });

  render() {
    const { pins, reviews, match, searchQuery, fromRubricator } = this.props;
    if (!match.isExact || !pins) {
      return null;
    }

    if (!pins.length) {
      return null;
    }

    const isButtonBackVisible = indx => indx === 0 && !!(searchQuery || fromRubricator);

    const pointTopClass = indx => classNames({
      'point-modal__content-top': true,
      'point-modal__content-top--padding': isButtonBackVisible(indx)
    })

    return (
      <MetaPage {...this.getMeta(pins[0])} className="point-modal">
        <div className="modal__content">
          <Scrollbars
            style={{ width: "100%", height: "100%" }}
            renderTrackVertical={props => <div {...props} className="track-vertical-custom" />}
          >
            {pins.map((pin, indx) => {
              return (
                <Fragment key={pin.id}>
                  <div className={pointTopClass(indx)}>
                    { isButtonBackVisible(indx) && <div className="point-modal__arrow-left" onClick={this.goBack}></div> }
                    <div className={"reviews-title__img" + (pin.logo ? " reviews-title__img_custom" : "")}>
                      <img src={this.setImg(pin)} alt="review" />
                    </div>
                    <div className="reviews-title__content-description">
                      {pin.functions[0] && pin.functions[0].title}
                    </div>
                    <div className="point-modal__close" onClick={this.close} />
                    {pin.activeDateTo && (
                      <div className={"active-time"}>
                        <img src={clock} />
                        {`Работает до ${moment(pin.activeDateTo).format("D MMMM")}`}
                      </div>
                    )}
                  </div>

                  <div className="point-modal__content-block">
                    <h1 className="reviews-title__content-title">{pin.title}</h1>
                  </div>

                  {pin.starsRecommend.length > 0 && (
                    <div className="point-modal__content-block">
                      <div className="stars">
                        {pin.starsRecommend.length > 0 && (
                          <div className="star__title">
                            Эту точку {pin.starsRecommend.length > 1 ? "рекомендуют" : "рекомендует"}{" "}
                            {pin.starsRecommend.map(x => x.name).join(", ")}{" "}
                          </div>
                        )}
                        <div className="star__wrapper">
                          <div className="star__block">
                            <img src={starSvg} />
                          </div>
                          {pin.starsRecommend.map(star => (
                            <div className="star__block">
                              <img src={star.photo} />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="point-modal__content-block">
                    { !pin.isContactsShown && (
                        <UIRoundedButton color="king" onClick={this.toggleCurtain(pin)}>
                          Показать контакты
                        </UIRoundedButton>
                      )}
                    <div className={clsx(
                      "point-modal__content-block__content",
                      !pin.isContactsShown && "point-modal__content-block__content--hidden")
                    }>
                      {pin.activeDateTo && (
                        <div className={"active-time"}>
                          <img src={clock} />
                          {`Работает до ${moment(pin.activeDateTo).format("D MMMM")}`}
                        </div>
                      )}
                      {pin.schedule && (
                        <div
                          className="content-block-l2 reviews-content reviews-content__schedule"
                          dangerouslySetInnerHTML={this.createMarkup(pin.schedule)}
                        />
                      )}
                      <div className={clsx(
                        "reviews-content",
                        pin.activeDateTo && "content-block-l2"
                      )}>
                        {pin.address} <br />
                        <a href={`tel:${pin.phone}`} onClick={this.handlePhoneClick}>{pin.phone}</a> <br />
                        <a href={pin.url} target="_blank" rel="noopener noreferrer" onClick={this.handleUrlClick(pin)}>
                          {pin.url}
                        </a>{" "}
                        <br />
                        <a href={`mailto:${pin.email}`}>{pin.email}</a>
                      </div>
                    </div>

                  </div>

                  <div className="point-modal__content-block">
                    <div className="reviews-content" dangerouslySetInnerHTML={this.createMarkup(pin.description)} />
                  </div>
                  { (pin.blogUrl || pin.articleUrl) && (
                    <div className="point-modal__content-block point-modal__content-block--narrow">
                      { pin.articleUrl && this.renderButtonLink(pin.articleUrl, 'Читать статью') }
                      { pin.blogUrl && this.renderButtonLink(pin.blogUrl, 'Читать блог') }
                    </div>
                  )}

                  <div className="point-modal__content-block point-modal__content-block--narrow">
                    <CheckIn pin={pin} checkIn={this.handleCheckIn.bind(this, pin)}></CheckIn>
                  </div>

                  <div className="point-modal__content-block point-modal__content-block--narrow">
                    {this.renderButtons(pin)}
                  </div>

                  { pin.fundUrl && (
                    <div className="point-modal__content-block point-modal__content-block--narrow">
                      { this.renderDonate(pin) }
                    </div>
                  )}

                  {reviews.length > 0 && (
                    <div className="point-modal__content-bottom">{this.reviewView(reviews)}</div>
                  )}
                </Fragment>
              );
            })}
          </Scrollbars>
        </div>
      </MetaPage>
    );
  }
}

export default withRouter(ModalPin);
